import React from "react";
import { Dialog, DialogContent, DialogTitle, List, ListItem, Typography, IconButton } from "@mui/material";
import Icon from "@mdi/react";
import { mdiClose } from "@mdi/js";
import { useTranslation } from "react-i18next";

const SuicidalThoughtsAndBehaviorsView = ({ open, onClose} : {open: boolean, onClose: () => void}) => {
  const { t } = useTranslation('generic');
  return (
    <Dialog open={open} onClose={onClose}>
        <DialogTitle id="suicidal-thoughts-dialog-title">{t("Suicidal thoughts and behaviors")}</DialogTitle>
      <IconButton
          aria-label={t("Close")}
          onClick={onClose}
          sx={() => ({
            position: 'absolute',
            right: 8,
            top: 8
          })}
        >
          <Icon path={mdiClose} size={1.2} />
        </IconButton>
      <DialogContent dividers aria-labelledby="suicidal-thoughts-dialog-title">
        <Typography>
          {t("If you're thinking about suicide or hurting yourself, are worried about a friend or loved one, or would like emotional support, the Lifeline network is available 24/7 and experience helping people in crisis. Your call or text is confidential and free. You can call the Suicide and Crisis Lifeline in the United States right now:")}
        </Typography>
        <List sx={{ listStyleType: 'disc', listStylePosition: 'inside' }}>
          <ListItem sx={{ display: 'list-item' }}>{t("Call or text: 988")}</ListItem>
          <ListItem sx={{ display: 'list-item' }}>{t("Español: 1-888-628-9454")}</ListItem>
          <ListItem sx={{ display: 'list-item' }}>{t("Chat online:")} <a href="https://988lifeline.org/" target="_blank" rel="noopener noreferrer">https://988lifeline.org/</a></ListItem>
        </List>
        <Typography>
          {t("Or text the Crisis TextLine now, also free and confidential:")}
        </Typography>
        <List sx={{ listStyleType: 'disc', listStylePosition: 'inside' }}>
          <ListItem sx={{ display: 'list-item' }}>{t("SMS in the US or Canada: 741741")}</ListItem>
          <ListItem sx={{ display: 'list-item' }}>{t("Chat using WhatsApp or Browser:")} <a href="https://www.crisistextline.org/" target="_blank" rel="noopener noreferrer">https://www.crisistextline.org/</a></ListItem>
        </List>
        <Typography>
          {t("For other countries:")}
        </Typography>
        <List sx={{ listStyleType: 'disc', listStylePosition: 'inside' }}>
          <ListItem sx={{ display: 'list-item' }}><a href="https://support.google.com/websearch/answer/11181469" target="_blank" rel="noopener noreferrer">https://support.google.com/websearch/answer/11181469</a></ListItem>
          <ListItem sx={{ display: 'list-item' }}><a href="https://befrienders.org" target="_blank" rel="noopener noreferrer">https://befrienders.org</a></ListItem>
        </List>
      </DialogContent>
    </Dialog>
  );
};

export default SuicidalThoughtsAndBehaviorsView;
